import moment from "moment";
import AppLogo from "../../components/AppLogo";
import { StarSvg } from "../../components/Assets";
import DateText from "../../components/DateText";
import SmallBanner from "../../components/SmallBanner";
import { CEO_TYPES, REVIEW_STATUS_CODE } from "../../constants/AppConstants";
import useAuth from "../../hooks/useAuth";
import { AI_COMMENT,CEO_COMMENT } from "../../text-data";
import AppUtils from "../../utils";
import formatDateToKoreanDDMM from "../../utils/formatDateToKoreanDDMM";
import ReviewBoxBtns from "./ReviewBoxBtns";
import ImageGallery from "react-image-gallery";


import {
  kEXCLUDED,
  kEXPIRED,
  kFAILED,
  kPENDING,
  kSUCCESS,
  kUNANSWERED,
  key2Kr,
} from "./ReviewStatusKeys";
import { useState ,useEffect} from "react";
import ReviewApi from "../../apis/review.api";

export const getReviewStatus = (status) => {
  switch (status) {
    case REVIEW_STATUS_CODE.UNANSWERED.code:
      return kUNANSWERED;

    case REVIEW_STATUS_CODE.PENDING.code:
      return kPENDING;

    case REVIEW_STATUS_CODE.SUCCESS.code:
      return kSUCCESS;

    case REVIEW_STATUS_CODE.FAILED.code:
      return kFAILED;

    case REVIEW_STATUS_CODE.EXCLUDED.code:
      return kEXCLUDED;

    case REVIEW_STATUS_CODE.EXPIRED.code:
      return kEXPIRED;
    default:
      break;
  }
};

const ReviewStatusTag = ({ reviewStatus }) => {
  const colors = [
    "#29ACE4",
    "#28B468",
    "#F25467",
    "#683DE1",
    "#F25467",
    "#8B919E",
  ];
  const bgColors = [
    "#F5FCFF",
    "#F0F9F4",
    "#FFF6F8",
    "#F6F3FF",
    "#FFF6F8",
    "#F8F9FC",
  ];

  const status = [
    kUNANSWERED,
    kSUCCESS,
    kEXPIRED,
    kPENDING,
    kFAILED,
    kEXCLUDED,
  ];

  const i = status.indexOf(reviewStatus);

  if (i < 0) {
    return <></>;
  }
  return (
    <div
      className="px-2 py-0.5 rounded-full text-xs"
      style={{ backgroundColor: bgColors[i], color: colors[i] }}
    >
      <b>{key2Kr(status[i])}</b>
    </div>
  );
};

const ReviewFoodTag = ({ reviewMenu }) => {
  return (
    <span
      className="px-2 py-0.5 rounded-full text-sm mr-2.5 py-1.5 px-3"
      style={{ backgroundColor:'#F5F7FF', color:'#3451D7',borderRadius:'6px'
         }}
    >
      <b>{reviewMenu}</b>
    </span>
  );
};
const ReviewFoodTagList = ({reviewMenus}) => {
  var items = [];
  reviewMenus?.split(',').forEach(e=>{
  items.push(<ReviewFoodTag reviewMenu={e} />)
  })
  return (
    <div>
      {items}
    </div>

  );
};


const ReviewImage = ({ images }) => {
  if (images === null || !images?.length) {
    return <></>;
  }
  else{
    images = images?.split(',');
    let imageData=[];
    images.forEach(e => {
      imageData.push({original:e});
    });
    return (
      <div className="relative">
        <ImageGallery items={imageData}
        showIndex={true}
        showFullscreenButton={false}
        showNav={false}
        autoPlay={true}
        showBullets={false}
        showThumbnails = {false}
        showPlayButton={false}
        slideInterval={5000}
        />

      </div>
    );
  }
};

export const isCheckExpired = (reg_dttm) => {
  const givenDate = moment(reg_dttm?.slice(0, -6));
  const today = moment();
  const differenceInDays = givenDate.diff(today, "days");
  return differenceInDays >= 30;
};

const ReviewBox = (props) => {
  let {
    review_reg_dt,
    member_nickname,
    app_name,
    rating,
    review_idx,
    contents,
    reg_dttm,
    comment_reg_status_code,
    ai_type1_comment_history_idx,
    ai_type1_comment,
    store_name,
    images_url,
    isEdit,
    isNotUsePostDay,
    postAfterDays,
    isWriteComment,
    refreshReview,
    textAreaHeight,
    additionCommentList,
    store_idx,
    ai_comment_modify_yn,
    menu_name,
    comment_reg_dt,
    comment_reg_result_msg
  } = props;  
  images_url = images_url;
  
  const { ceoInfo } = useAuth();
  const ceoType = ceoInfo?.ceo_type;

  const StoreResponse = ({
    foodStoreName,
    reviewResponse,
    reviewResponsedAt,
    isCommentPosting,
    reviewStatus,
    commentWillBePostedAt,
    isCommentedByAI,
  }) => {
    const [additionalComment, setAdditionalComment] = useState('');
    const [commenterName, setCommenterName] = useState('');
    const [estimatedReplyDate,setEstimatedReplyDate] = useState(null);
    useEffect(() => {
      additionCommentList.forEach(e => {
        if (e.store_idxs?.includes(store_idx)) {
          setAdditionalComment(e.content);
        }
      });
      if (reviewStatus === REVIEW_STATUS_CODE.SUCCESS.code) {
        setCommenterName(CEO_COMMENT);
      }
      else if (isCommentedByAI && reviewStatus !== REVIEW_STATUS_CODE.SUCCESS.code) {
        setCommenterName(AI_COMMENT);
      }
      else if (isCommentedByAI === null) {
        setCommenterName("");
      }
      else if (!isCommentedByAI) {
        setCommenterName(CEO_COMMENT);
      }
      setEstimatedReplyDate(getDayBySavedSetting(review_reg_dt));
    }, []);
    const getDayBySavedSetting = (reviewRegDt) => {
      const reviewDate = moment(reviewRegDt, 'YYYYMMDD')
      const currentDate = moment();
      const estimatedReplyDate = reviewDate.add(postAfterDays, "day");
      if (isNotUsePostDay) return null;
      return estimatedReplyDate.isAfter(currentDate) ? estimatedReplyDate : null;
    };

    const isShowAlertPostingReply = () => {
      const currentDate = moment();
      const estimatedReplyDate =  moment(review_reg_dt, 'YYYYMMDD').add(postAfterDays, "day");
      return estimatedReplyDate.startOf('day').isSame(currentDate.startOf('day'));
    };

    const isShowComment =  ai_type1_comment !== undefined && ai_type1_comment !== null && ai_type1_comment?.trim() !== "";

    return (
      <div className={(isShowComment && "bg-fa ") + " rounded-xl p-4 flex flex-col gap-5"}>
        {!isEdit && (
          <>
            {/* {isCheckExpired(reg_dttm) &&
              reviewStatus === REVIEW_STATUS_CODE.EXPIRED.code && (
                <div className="text-center text-darkblue py-3">
                  🥺 댓글 등록 기간이 만료되었어요.
                </div>
              )} */}

            {/* {reviewStatus === REVIEW_STATUS_CODE.EXCLUDED.code && (
              <div className="text-center text-darkblue py-3">
                🙏 댓글 등록이 제외된 리뷰예요.
              </div>
            )} */}

            {isShowComment ? (
              <div className="bg-fa rounded-xl flex flex-col gap-5">
                <div className="flex justify-between items-center gap-1">
                  <b className="text-darkblue text-base">
                    {commenterName}
                  </b>
                  {((reviewStatus === REVIEW_STATUS_CODE.SUCCESS.code || reviewStatus === REVIEW_STATUS_CODE.EXPIRED.code) && comment_reg_dt !== null )&&
                    <DateText>
                      {AppUtils.formatDate(comment_reg_dt, "YYYY.MM.DD")}
                    </DateText>
                  }
                </div>

                <>
                  {estimatedReplyDate  && !isNotUsePostDay && (reviewStatus === REVIEW_STATUS_CODE.PENDING.code || reviewStatus === REVIEW_STATUS_CODE.UNANSWERED.code) && ceoType ==='PREMIUM'  ? (
                    <SmallBanner>
                      ⏰ {formatDateToKoreanDDMM(estimatedReplyDate)}에
                      댓글이 등록될 예정이예요.
                    </SmallBanner>
                  ) : null}
                </>
                
                <>
                {isShowAlertPostingReply() && !isNotUsePostDay && reviewStatus === REVIEW_STATUS_CODE.PENDING.code && ceoType ==='PREMIUM' ? (
                  <SmallBanner>
                    ✅ 등록 요청이 접수되어 <br /> 
                    사장님 사이트에 등록될 예정이에요.
                  </SmallBanner>
                ): null}
                </>

                <span
                  dangerouslySetInnerHTML={{ __html: ai_type1_comment }}
                  className="text-darkblue"
                />
                {<div className="mt-2"><span
                    dangerouslySetInnerHTML={{ __html: additionalComment }}
                    className="text-darkblue"
                  />
                  </div>}

              </div>
            ) : ''}
          </>
        )}
      </div>
    );
  };

  
  return (
    <div className={`${isEdit ? 'review-box-edit' : 'lite-border rounded-3xl'} px-5 py-6 w-full review-box`}>
      <div className="flex justify-between mb-4">
        <DateText>{moment(review_reg_dt).format("YYYY.MM.DD")}</DateText>
        <ReviewStatusTag
          reviewStatus={getReviewStatus(comment_reg_status_code)}
        />
      </div>

      <div className="flex justify-between mb-4 items-center">
        <div className="flex gap-2.5 items-center">
          <AppLogo appName={app_name} isByName={true} />
          <b className="text-darkblue">{member_nickname}</b>
        </div>
        <div className="flex items-center gap-1">
          <img src={StarSvg} className="w-3.5 h-3.5"></img>
          <b className="text-lg">{rating}점</b>
        </div>
      </div>

      <div>
        <ReviewImage images={images_url} />
      </div>
      <div className="mb-8 mt-6">
        {/* Update here */}
        <b className="text-darkblue">[{review_idx}] {store_name}</b>
      </div>
      <div className="mb-6">
        <span
          dangerouslySetInnerHTML={{ __html: contents }}
          className="text-darkblue"
        />
      </div>
      <div className="mb-6">
      <ReviewFoodTagList reviewMenus = {menu_name}/>
      </div>
      {isEdit && (<hr style={{ marginLeft: '-20px', width: 'calc(100% + 40px)' }}></hr>)}
      {!isEdit && (
        <StoreResponse
          foodStoreName={store_name}
          isCommentedByAI={ai_type1_comment !== null && ai_comment_modify_yn ==='N' }
          reviewStatus={getReviewStatus(comment_reg_status_code)}
        />
      )}

      <ReviewBoxBtns        
        reg_dttm={reg_dttm}
        isNotUsePostDay={isNotUsePostDay}
        comment_reg_status_code={comment_reg_status_code}
        reviewResponse={ai_type1_comment}
        isEdit={isEdit}
        isWriteComment={isWriteComment}
        reviewItem={props}
        isCommented={ai_type1_comment}
        isUseAIComment={ai_type1_comment_history_idx !== null}
        refreshReview={refreshReview}
        textAreaHeight={textAreaHeight}
        comment_reg_result_msg={comment_reg_result_msg}
      />
      {/* {isEdit && <div className="h-[55px]"></div>} */}
    </div>
  );
};

export default ReviewBox;
